<template>
  <div class="item" @click="focus">
    <slot></slot>
    <input
      :type="inputType"
      class="input-list"
      ref="input"
      :value="value"
      :placeholder="placeholder"
      @input="$emit('input', $event.target.value)">
  </div>
</template>

<script>
export default {
  props: {
    inputType: {
      type: String
    },

    value: {},

    placeholder: {
      type: String
    }
  },
  methods: {
    focus: function () {
      this.$refs.input.focus()
    }
  }
}
</script>
